import { createActionCreators, createReducerFunction } from 'immer-reducer'
import { BasicEntityState } from 'modules/constants'
import { BasicEntityImmerReducer } from 'modules/utils/helpers/BasicEntityImmerReducer'
import { ListResponse } from 'types/api'
import {
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  TargetSkuUpdateDTO,
  PedigreedGrowerTargetSku,
  PedigreedGrowerTargetSkuCreateDTO,
  PedigreedGrowerTargetSkuState,
} from '../common/types'

const initialState: PedigreedGrowerTargetSkuState = {
  ...BasicEntityState,
  updateCounter: 0,
  totalFarmerOrdersSku: 0,
  totalFarmerOrdersSkuPreviousYear: 0,
  totalTargetValues: 0,
}

type PedigreedGrowerMeta = {
  total_target_values: number
  total_farmer_orders_sku: number
  total_farmer_orders_sku_previous_year: number
}

class PedigreedGrowerTargetSkuReducer extends BasicEntityImmerReducer<
  PedigreedGrowerTargetSku,
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  PedigreedGrowerTargetSkuCreateDTO,
  TargetSkuUpdateDTO,
  PedigreedGrowerTargetSkuState
> {
  updateOccurred() {
    this.draftState.updateCounter += 1
  }
  listRequestSucceed(response: ListResponse<PedigreedGrowerTargetSku, PedigreedGrowerMeta>) {
    super.listRequestSucceed(response)
    const { total_target_values, total_farmer_orders_sku, total_farmer_orders_sku_previous_year } = response.meta || {}
    this.draftState.totalTargetValues = total_target_values || 0
    this.draftState.totalFarmerOrdersSku = total_farmer_orders_sku || 0
    this.draftState.totalFarmerOrdersSkuPreviousYear = total_farmer_orders_sku_previous_year || 0
  }
}

export const PedigreedGrowerTargetSkuActions = createActionCreators(PedigreedGrowerTargetSkuReducer)
export default PedigreedGrowerTargetSkuActions
export const reducer = createReducerFunction(PedigreedGrowerTargetSkuReducer, initialState)
